module.exports = __webpack_public_path__ + "img/Grimaldi_lines.83654c27.png";